import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
    AddressbookItem,
    AddressbookItems,
    BicDetailsResponse,
    COUNTERPARTY_ADMINISTRATION_API_KEY,
    PartyAccount,
    SingleVerificationResponse
} from './counterparty-administration.model';

@Injectable({ providedIn: 'root' })
export class CounterpartyAdministrationResource {
    private readonly httpClient = inject(HttpClient);
    private apiKey = inject(COUNTERPARTY_ADMINISTRATION_API_KEY, { optional: true });

    private readonly baseUrl: string = '/services/bspc-counterparty-administration/api';

    private getApiXHeader(): HttpHeaders {
        if (!this.apiKey) {
            throw Error('Missing API key for bspc-counterparty-administration');
        }

        return new HttpHeaders().set('X-Api-Key', this.apiKey);
    }

    public setApiKey(key: string) {
        this.apiKey = key;
    }

    public postVerifyCounterParty(partyAccount: PartyAccount): Observable<SingleVerificationResponse> {
        const headers = this.getApiXHeader();
        return this.httpClient.post<SingleVerificationResponse>(`${this.baseUrl}/counterparty/verification`, partyAccount, {
            headers
        });
    }

    public getAddressbookItems(): Observable<AddressbookItems> {
        const headers = this.getApiXHeader();
        return this.httpClient.get<AddressbookItems>(`${this.baseUrl}/addressbookitems`, {
            headers
        });
    }

    public postAddressbookItem(addressbookItem: AddressbookItem): Observable<void> {
        const headers = this.getApiXHeader();
        return this.httpClient.post<void>(`${this.baseUrl}/addressbookitems`, addressbookItem, {
            headers
        });
    }

    public putAddressbookItem(adressbookItem: AddressbookItem): Observable<void> {
        const headers = this.getApiXHeader();
        return this.httpClient.put<void>(`${this.baseUrl}/addressbookitems`, adressbookItem, {
            headers
        });
    }

    public deleteAddressbookItem(addressbookItemId: string): Observable<void> {
        const headers = this.getApiXHeader();
        return this.httpClient.delete<void>(`${this.baseUrl}/addressbookitems/${addressbookItemId}`, {
            headers
        });
    }

    public getBankDetails(bic: string): Observable<BicDetailsResponse> {
        const headers = this.getApiXHeader();
        return this.httpClient.get<BicDetailsResponse>(`${this.baseUrl}/bics/${bic}/bankdetails`, {
            headers
        });
    }
}
